import { isBrowser } from 'ws-scripts/modules/environment';
import { viewportWidthSizes } from '../global-constants';
/**
 * helper that lets you know if you're on a small screen (one that is under 768px in width)
 *
 * @param viewportWidth
 * @returns {boolean}
 */
const { SM_VIEWPORT_WIDTH_SIZE } = viewportWidthSizes;

export const getIsSmallScreen = (viewportWidth) => {
	return viewportWidth < SM_VIEWPORT_WIDTH_SIZE;
};

// "Grid View" only kicks in above tablet size.
// A list-type horizontal card still shows for > 480 && < 768
export const selectIsGridLayout = (state) => {
	return state.layout.layout === 'grid' && !state.layout.isSmallScreen;
};

// Used to handle legacy "non-simplified" list view styling on Desktop.
// TODO: this should be refactored in the future to have ONE state for the list layout
export const selectIsListLayout = (state) => {
	return state.layout.layout === 'list' && !state.layout.isSmallScreen;
};

export const selectIsTabbedLayout = (state) => {
	return state.layout.isSmallScreen || selectIsGridLayout(state);
};

/**
 * Determines whether the compare icon should display over the vehicle image.
 * Shared by Media (to render CompareIconButton) and useFooterCTAs (to hide
 * the footer compare checkbox when the overlay is active).
 *
 * @param {string} enableCompare - Preference value ('true' or 'false')
 * @param {string} enableCompareOverImage - Preference value ('true' or 'false')
 * @param {boolean} isGridLayout - Whether current layout is grid view
 * @param {boolean} isSmallScreen - Whether current screen is small (mobile/tablet)
 * @returns {boolean}
 */
export const getShouldShowCompareOverImage = (
	enableCompare,
	enableCompareOverImage,
	isGridLayout,
	isSmallScreen
) =>
	enableCompare === 'true' &&
	enableCompareOverImage === 'true' &&
	(isGridLayout || isSmallScreen);

export const getSpotIconSize = (deviceType) => {
	const screen =
		deviceType === 'DESKTOP' && isBrowser && window.screen?.width > 1200
			? 'HIRES'
			: deviceType;
	return (
		{
			HIRES: '104',
			DESKTOP: '96',
			MOBILE: '80'
		}[screen] ?? '96'
	);
};
